<template>
  <v-container class="my-12 px-4">
    <v-row justify="center">
      <v-col xs12 class="px-2 text-center">
        <h1>404</h1>
        <small v-if="customText"> {{ customText }}</small>
        <small v-else>{{
          $t(
            "common:errorMessage.pageDoesNotExist.text",
            "The page you are looking for does not exist"
          )
        }}</small>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "NoPage",
  props: {
    customText: {
      type: String,
      default: null
    }
  }
};
</script>
